// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarAddComment-cls1_u-F","cls2":"SidebarAddComment-cls2_lCR SidebarAddComment-cls1_u-F"};